import React from 'react';
import { useNavigate } from 'react-router-dom';
import './accessDenied.css';

export default function AccessDeniedModal({ show = true, message }){
  const navigate = useNavigate();
  if(!show) return null;
  const handleBack = () => {
    try{
      navigate(-1);
    }catch(e){
      // fallback to home if navigation fails
      navigate('/');
    }
  };
  return (
    <div className="modal-overlay" onClick={handleBack}>
      <div className="modal-box" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h4>Cảnh báo</h4>
          <button className="modal-close" onClick={handleBack}>✕</button>
        </div>
        <div className="modal-body">
          <p>{message || 'Bạn không có quyền truy cập trang này.'}</p>
          <div style={{ marginTop: 12 }}>
            <button onClick={handleBack}>Quay lại</button>
          </div>
        </div>
      </div>
    </div>
  );
}
